import { useVisitorIdentification } from "../hooks/useVisitorIdentification";

/**
 * Rendert niets — bestaat alleen om `useVisitorIdentification` op te hangen
 * binnen de Auth- en OrganizationProvider. Zonder deze wrapper zou de hook in
 * `App` moeten, en dat bestand is een gedeelde insertion-zone.
 */
export default function VisitorIdentification(): null {
  useVisitorIdentification();
  return null;
}
